import { stitch } from 'keo';
import Headroom from 'react-headroom';
import PropTypes from 'prop-types';
import r from 'render-dom';

import Header from 'components/shared/Header';

import NavSection from './NavSection';

const propTypes = {
    buttons: PropTypes.node,
    icon: PropTypes.node,
    navTitle: PropTypes.node,
    style: PropTypes.object,
    title: PropTypes.string.isRequired,
};

const baseStyle = {
    overflow: 'hidden',
    zIndex: 999,
};

const render = ({ props }) => {
    const { buttons, navTitle, onNavClick, style = {}, title, ...passProps } = props;

    return (
        r(Headroom, {
            ...passProps,
            style: { ...baseStyle, ...style },
        }, [
            r(Header, {
                buttons,
                icon: props.icon,
                navTitle,
                title,
            }),
            r(NavSection, { props }),
        ])
    );
};

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/components/shared/StickyHeader/StickyHeader.js